//core
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import i18n from "i18next";

//action
import {getStatus, setUser, updateUserInfo, userSliceState} from "./index";

//hooks
import routes from "./../../../navigation/routes";

//store
import { selectUploadConfigData } from "../configuration/selectors";

//hooks
import { useLanguage } from "../configuration/useLanguage";
import { useConfiguration } from "../configuration/useConfiguration";

export type stateUser = {
  user: userSliceState
};


export const useUser = () => {
  const dispatch = useDispatch();
  let location = useLocation();
  let navigate = useNavigate();

  const { setLanguageData } = useLanguage();
  const { getUploadConf } = useConfiguration();

  const uploadConfigData = useSelector(selectUploadConfigData);
  const { user, status } = useSelector((state: stateUser) => state.user);

  const [ userIsAdmin, setUserIsAdmin ] = useState(false);
  const [ userIsAff, setUserIsAff ] = useState(false);
  const [ userIsApplicant, setUserIsApplicant ] = useState(false);
  const [ userIsAgent, setUserIsAgent ] = useState(false);
  const [ userIsCashier, setUserIsCashier ] = useState(false);
  const [langsData, setLangsData] = useState<any>([]);

  useEffect(() => {
    if (!uploadConfigData) {
      getUploadConf();
    }
  }, []);

  useEffect(() => {
    if (!!uploadConfigData) {
      setLangsData(uploadConfigData.locales.reduce((acc: any[], locale: string) => {
        const short = uploadConfigData.localesShortCodes.find((sc: string) => locale.startsWith(sc));
        if (short) acc.push({ code: locale, lang: short });
        return acc;
      }, []))
    }
  }, [uploadConfigData]);

  useEffect(() => {
    if (!!user && !!user.user) {
      if (!!user.user.locale) {
        //const localLang = localStorage.getItem('i18nextLng');
        const userLang = user.user.locale.split('_')[0];

        if (uploadConfigData.localesShortCodes.includes(userLang)) {
          localStorage.setItem('i18nextLng', userLang);
          i18n.changeLanguage(userLang);
        } else {
          const languages = uploadConfigData.locales.reduce((acc: any[], locale: string) => {
            const short = uploadConfigData.localesShortCodes.find((sc: string) => locale.startsWith(sc));
            if (short) acc.push({ code: locale, lang: short });
            return acc;
          }, [])

          localStorage.setItem('i18nextLng', languages[0].lang);
          i18n.changeLanguage(languages[0].lang);
          setLanguageData(languages[0].code);
        }
      }

      if (user.user.namespace === "admin") {
        setUserIsAdmin(true);
      } else {
        setUserIsAdmin(false);
      }

      if (user.user.namespace === "affiliate") {
        setUserIsAff(true);
      } else {
        setUserIsAff(false);
      }

      if (user.user.namespace === "applicant") {
        setUserIsApplicant(true);
      } else {
        setUserIsApplicant(false);
      }

      if (user.user.namespace === "agent") {
        setUserIsAgent(true);
      } else {
        setUserIsAgent(false);
      }

      if (user.user.namespace === "cashier") {
        setUserIsCashier(true);
      } else {
        setUserIsCashier(false);
      }
    } else {
      const localUser = localStorage.getItem('user');
      const hasUser = !!localUser;

      if (hasUser) {
        const user = JSON.parse(localUser);
        if (user.user.namespace === "admin") {
          setUserIsAdmin(true);
        }
        if (user.user.namespace === "affiliate") {
          setUserIsAff(true);
        }
        if (user.user.namespace === "applicant") {
          setUserIsApplicant(true);
        }
        if (user.user.namespace === "agent") {
          setUserIsAgent(true);
        }
        if (user.user.namespace === "cashier") {
          setUserIsCashier(true);
        }
      } else {
        setUserIsAdmin(false);
        setUserIsAff(false);
        setUserIsApplicant(false);
        setUserIsAgent(false);
        setUserIsCashier(false);
      }
    }
  }, [user]);

  useEffect(() => {
    if (!!user) {
      // @ts-ignore
      if (!!location.state && location?.state?.hasOwnProperty('from')) {
        // @ts-ignore
        const fromPage: any = !!location.state && !!location?.state?.from && !!location?.state?.from?.pathname ? `${location?.state?.from.pathname}${location?.state?.from.search}` : routes.root;
        setTimeout(() => {
          navigate(fromPage, {replace: true});
        }, 50)
      }
    }
  }, [user]);

  const setUserData = (data: userSliceState) => dispatch(setUser(data));
  const setUpdateUserInfo = (data: any) => dispatch(updateUserInfo(data));

  const getUserStatus = () => dispatch(getStatus());

  return {
    user,
    status,
    userIsAdmin,
    userIsAff,
    userIsApplicant,
    userIsAgent,
    userIsCashier,
    setUserData,
    setUpdateUserInfo,
    getUserStatus,
  }
}
